import {
  faCalendarCheck,
  faFileInvoiceDollar,
  faFileLines,
  faVial,
  type IconDefinition
} from '@fortawesome/free-solid-svg-icons';

import { ENCOUNTER_TYPES } from '@/types/encounter';
import type { PersonNavDefinition } from '@/utils/personNavOptions';

const ICONS: Record<string, IconDefinition> = {
  [ENCOUNTER_TYPES.APPOINTMENT]: faCalendarCheck,
  [ENCOUNTER_TYPES.APPOINTMENT_ATTENDANCE]: faCalendarCheck,
  [ENCOUNTER_TYPES.DRUG_SCREEN]: faVial,
  [ENCOUNTER_TYPES.FORM_ANSWER_GROUP]: faFileLines,
  [ENCOUNTER_TYPES.CASE_RATE_BILLING_PERIOD]: faFileInvoiceDollar,
  [ENCOUNTER_TYPES.ADD_ON]: faFileInvoiceDollar,
  [ENCOUNTER_TYPES.ADDITIONAL_SERVICE]: faFileInvoiceDollar
};

/**
 * The rail entry for the encounter a person has open.
 *
 * An encounter is not one of a person's standing pages, so this entry only exists while one is
 * open. It is labelled "Encounter" whatever the type — the type reads off the icon and off the
 * page itself, and a per-type label made the entry the longest line in the rail. `encounterType`
 * is passed through from the route rather than re-derived, so the link points back at the URL the
 * user is already on.
 *
 * The path is the encounter root and is not `exact`, so the entry stays current on the
 * encounter's own sub-pages (billing, a new drug screen) the way a person page owns its children.
 */
const encounterNavItem = ({
  encounterType,
  encounterId
}: {
  encounterType: string;
  encounterId: string;
}): PersonNavDefinition => ({
  label: 'Encounter',
  path: `/encounters/${encounterType}/by_id/${encounterId}`,
  icon: ICONS[encounterType] ?? faFileLines
});

export default encounterNavItem;
